import React from "react";

export default class Newsletter extends React.Component {
  render() {
    const inputStyle = {
      position: "absolute",
      left: "-5000px"
    };

    return (
      <div className="bg-blue text-white text-center pt-5 pb-5">
        <div className="container">
          <h2 className="mb-3 text-uppercase text-white">Monthly Bulletin</h2>
          <div className="row">
            <div className="col-12 col-md-8 offset-md-2">
              <p className="font-weight-bold">
                ISI monthly bulletin offers a compilation of law and policy
                developments, new resources, announcements and opportunities on
                statelessness from around the world.
              </p>
            </div>
          </div>

          <div id="mc_embed_signup">
            <form
              action="https://institutesi.us10.list-manage.com/subscribe/post?u=e5784428f36e3696ddd26f1dd&amp;id=38e14a688a"
              method="post"
              id="mc-embedded-subscribe-form"
              name="mc-embedded-subscribe-form"
              className="validate"
              target="_blank"
              noValidate
            >
              <div
                id="mc_embed_signup_scroll"
                className="row d-flex align-items-center"
              >
                <div className="col-12 col-md-8 mb-3 mb-md-0">
                  <input
                    type="email"
                    name="EMAIL"
                    className="form-control newsletter-form-control"
                    id="mce-EMAIL"
                    placeholder="email address"
                    required
                  />
                  <div style={inputStyle} aria-hidden="true">
                    <input
                      type="text"
                      name="b_e5784428f36e3696ddd26f1dd_38e14a688a"
                      tabIndex="-1"
                    />
                  </div>
                </div>
                <div className="col-12 col-md-4">
                  <div className="clear">
                    <input
                      type="submit"
                      defaultValue="Subscribe"
                      name="subscribe"
                      id="mc-embedded-subscribe"
                      className="btn btn-default btn-block"
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Newsletter.js